import React from 'react'
import { Provider } from 'react-redux'
import throttle from 'lodash.throttle'
import createStore from './src/state/index'
import { saveState } from './src/state/localStorage'
import { CookieConsentProvider } from './src/contexts/CookieConsentContext'
import { AccountProvider } from './src/contexts/AccountContext'
import { CookieConsentBanner } from './src/components/CookieConsentBanner'
import PropTypes from 'prop-types'

const ReduxProvider = ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  const store = createStore()
  store.subscribe(
    throttle(() => {
      saveState(store.getState())
    }, 1000)
  )
  return (
    <CookieConsentProvider>
      <AccountProvider>
        <Provider store={store}>{element}</Provider>
        <CookieConsentBanner />
      </AccountProvider>
    </CookieConsentProvider>
  )
}
ReduxProvider.propTypes = {
  element: PropTypes.node.isRequired,
}

export default ReduxProvider
